import { render, staticRenderFns } from "./AudioAnnotationTestModelArea.vue?vue&type=template&id=5ba6ad1a&scoped=true&"
import script from "./AudioAnnotationTestModelArea.vue?vue&type=script&lang=js&"
export * from "./AudioAnnotationTestModelArea.vue?vue&type=script&lang=js&"
import style0 from "./AudioAnnotationTestModelArea.vue?vue&type=style&index=0&id=5ba6ad1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba6ad1a",
  null
  
)

export default component.exports